

























import {
  Vue, Component, Prop, PropSync,
} from 'vue-property-decorator';

@Component({})
export default class OnboardingUnitInfo extends Vue {
  @PropSync('onboardCount', {}) onboardCountSync!: any;

  @PropSync('selectedDateRange', {}) selectedDateRangeSync!: string;
}

